(function () {
    'use strict';

    const messages = {
        loading: 'Wysyłanie zgłoszenia…',
        success: 'Dziękuję. Zgłoszenie zostało przyjęte.',
        validation_error: 'Sprawdź zaznaczone pola i spróbuj ponownie.',
        rate_limited: 'Wysłano zbyt wiele prób. Spróbuj ponownie później.',
        origin_not_allowed: 'Nie udało się potwierdzić strony, z której wysłano formularz.',
        spam_check_failed: 'Nie udało się potwierdzić formularza. Odczekaj chwilę i spróbuj ponownie.',
        turnstile_failed: 'Nie udało się potwierdzić zabezpieczenia antyspamowego. Spróbuj ponownie.',
        body_too_large: 'Wiadomość jest zbyt długa.',
        invalid_request: 'Nie udało się odczytać formularza.',
        invalid_content_type: 'Nie udało się odczytać formularza.',
        notification_unavailable: 'Zgłoszenie nie zostało wysłane. Formularz jest chwilowo niedostępny. Twoje dane pozostały w formularzu — spróbuj ponownie później.',
        server_error: 'Formularz jest chwilowo niedostępny. Spróbuj ponownie później.',
        service_unavailable: 'Formularz jest chwilowo niedostępny. Spróbuj ponownie później.',
        network_error: 'Nie udało się połączyć z formularzem. Sprawdź internet i spróbuj ponownie.',
        missing_endpoint: 'Formularz nie został jeszcze uruchomiony. Napisz bezpośrednio na adres kontaktowy.'
    };
    const fieldMessages = {
        name: 'Podaj imię i nazwisko.',
        email: 'Podaj prawidłowy adres e-mail.',
        offer: 'Wybierz ofertę.',
        party_size: 'Podaj liczbę osób od 1 do 99.',
        message: 'Napisz, czego dotyczy zapytanie.'
    };

    function initContactForm(form) {
        const offer = form.elements.offer;
        const partySize = form.elements.party_size;
        const message = form.elements.message;
        const partyField = form.querySelector('[data-party-size-field]');
        const requiredMark = form.querySelector('[data-message-required]');
        const status = form.querySelector('[data-contact-status]');
        const submit = form.querySelector('[type="submit"]');
        const startedAt = form.elements.started_at;
        let submitting = false;

        startedAt.value = String(Math.floor(Date.now() / 1000));

        function setStatus(text, state) {
            status.textContent = text;
            status.dataset.state = state || '';
        }

        function clearFieldError(name) {
            const input = form.elements[name];
            const output = form.querySelector('[data-error-for="' + name + '"]');
            if (input) input.removeAttribute('aria-invalid');
            if (output) output.textContent = '';
        }

        function setFieldError(name, text) {
            const input = form.elements[name];
            const output = form.querySelector('[data-error-for="' + name + '"]');
            if (input) input.setAttribute('aria-invalid', 'true');
            if (output) output.textContent = text;
        }

        function syncConditionalFields() {
            const hasSelection = offer.value !== '';
            const isOther = offer.value === 'Inne';
            const isTaggedOffer = hasSelection && !isOther;

            partyField.hidden = !isTaggedOffer;
            partyField.setAttribute('aria-hidden', String(!isTaggedOffer));
            partySize.disabled = !isTaggedOffer;
            partySize.required = isTaggedOffer;
            if (isTaggedOffer && partySize.value === '') partySize.value = '1';
            message.required = isOther;
            requiredMark.hidden = !isOther;
            requiredMark.setAttribute('aria-hidden', String(!isOther));
            clearFieldError('offer');
            clearFieldError('party_size');
            clearFieldError('message');
        }

        function validate() {
            let firstInvalid = null;
            ['name', 'email', 'offer', 'party_size', 'message'].forEach(clearFieldError);
            Array.from(form.elements).forEach(function (input) {
                if (!input.name || input.disabled || typeof input.checkValidity !== 'function') return;
                if (!input.checkValidity()) {
                    setFieldError(input.name, fieldMessages[input.name] || messages.validation_error);
                    firstInvalid = firstInvalid || input;
                }
            });
            if (firstInvalid) {
                firstInvalid.focus();
                setStatus(messages.validation_error, 'error');
                return false;
            }
            return true;
        }

        offer.addEventListener('change', syncConditionalFields);
        form.addEventListener('input', function (event) {
            if (event.target && event.target.name) clearFieldError(event.target.name);
        });
        form.addEventListener('submit', async function (event) {
            event.preventDefault();
            if (submitting || !validate()) return;

            const endpoint = form.dataset.endpoint.trim();
            if (!endpoint) {
                setStatus(messages.missing_endpoint, 'error');
                return;
            }

            submitting = true;
            submit.disabled = true;
            setStatus(messages.loading, '');
            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                    body: new URLSearchParams(new FormData(form)).toString()
                });
                const result = await response.json().catch(function () {
                    return {ok: false, code: 'server_error'};
                });
                if (!response.ok || !result.ok) {
                    if (result.fields) {
                        Object.keys(result.fields).forEach(function (name) {
                            setFieldError(name, fieldMessages[name] || messages.validation_error);
                        });
                    }
                    setStatus(messages[result.code] || messages.server_error, 'error');
                    return;
                }

                form.reset();
                startedAt.value = String(Math.floor(Date.now() / 1000));
                syncConditionalFields();
                setStatus(messages.success, 'success');
            } catch (error) {
                setStatus(messages.network_error, 'error');
            } finally {
                submitting = false;
                submit.disabled = false;
            }
        });

        syncConditionalFields();
    }

    document.querySelectorAll('[data-marta-contact-form]').forEach(initContactForm);
}());
